import React from 'react';
import ReactDOM from 'react-dom';
import {Provider as ReduxProvider} from 'react-redux';
import {Route} from 'react-router';
import {ConnectedRouter} from 'connected-react-router';
import {loadableReady} from '@loadable/component';
import Eev from 'eev';

/* Bootstrapper */
import {initPostReduxStoreBoostrappers} from './core/bootstrap/storefrontBootstrap';

/* Core */
import StorefrontApiManager from '../universal/core/api/StorefrontApiManager';

/* Store */
import reduxJsonManager from '../universal/redux/core/json/reduxJsonManager';
import {createClientReduxStore} from './core/redux/clientReduxStore';

/* Event */
import hbusApiClient from '../universal/modules/analytics/hbus/hbusApiClient';
import webtrekkApiClient from '../universal/modules/analytics/webtrekk/webtrekkApiClient';

/* Utils */
import {createApiClient} from '../universal/common/network/apiUtils';
import {createHistory} from './common/history/historyUtils';

/* Components */
import AppDesktop from '../universal/components/AppDesktop';

/* Constants */
import {GLOBAL_HISTORY_NAMES} from './common/history/historyConstants';

/* Config */
import config from '../universal/appConfig';

/* Style */
import '../assets/styles/desktop/storefront.scss';


const history = createHistory();

if (!window.HbEventBus) {
  window.HbEventBus = new Eev();
}

if (process.env.BROWSER && window) {
  window[GLOBAL_HISTORY_NAMES.DESKTOP] = history;
}

const storefrontApiManager = new StorefrontApiManager({
  baseURL: config.api.clientUrl,
});

let customInitialState;

if (window.reduxStore) {
  customInitialState = reduxJsonManager.fromJSON(window.reduxStore.text);
  initPostReduxStoreBoostrappers(customInitialState);
}

const reduxStore = createClientReduxStore(
  {
    storefrontApiClient: createApiClient(storefrontApiManager),
    hbusApiClient,
    webtrekkApiClient,
    storefrontApiManager,
    history,
  },
  customInitialState,
);
const container = document.getElementById('container');

function run() {
  loadableReady(() => {
    ReactDOM.hydrate(
      <ReduxProvider store={reduxStore}>
        <ConnectedRouter history={history}>
          <Route
            path='/'
            component={AppDesktop}/>
        </ConnectedRouter>
      </ReduxProvider>,
      container,
    );
  });
}

async function loadAsyncModules(callback) {
  if (callback && typeof callback === 'function') {
    callback();
  }
}

loadAsyncModules(() => {
  run();
});
